import { Card, Badge, Text, Group, Button, Box } from '@mantine/core'
import SkillChips, { CHIPS_BOX_HEIGHT } from './SkillChips'

// #1080 案件カード。propsをそのまま描画するだけ（データ計算はRails側）。
// カードの高さを揃えるため、タイトル/説明は行数固定(min-height)、ボタンは下端に寄せる。
export default function PositionCard({ position }) {
  const {
    areaName,
    title,
    skills = [],
    priceLabel,
    nearestStation,
    requiredSkillsText,
    href,
    matchScore,
  } = position

  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Group justify="flex-end" gap={6} mb={4}>
        {typeof matchScore === 'number' && (
          <Badge color="brand">マッチ度 {matchScore}%</Badge>
        )}
        <Badge color="gray" variant="light">{areaName}</Badge>
      </Group>

      {/* タイトルは常に2行分の高さを確保(1行でも高さが揃う) */}
      <Text fw={600} lineClamp={2} lh={1.5} mb="xs" style={{ minHeight: '3em' }}>
        {title}
      </Text>

      <Text fw={700} size="xl" c="brand.7" mb="sm">
        {priceLabel}
      </Text>

      {skills.length > 0 ? <SkillChips skills={skills} /> : <Box style={{ height: CHIPS_BOX_HEIGHT }} mb="sm" />}

      <Text size="sm" c="dimmed" mb={2} lineClamp={1}>
        最寄り駅: {nearestStation || '—'}
      </Text>
      <Text size="sm" c="dimmed" lineClamp={2} lh={1.5} mb="md" style={{ whiteSpace: 'pre-line', minHeight: '3em' }}>
        {requiredSkillsText}
      </Text>

      <Button component="a" href={href} color="brand" fullWidth radius="md" mt="auto">
        詳細を見る
      </Button>
    </Card>
  )
}
